export const getFileNameFromURL = (url: string): string | undefined => {
  try {
    const urlObj = new URL(url)
    return urlObj.pathname.split("/").pop() || undefined
  } catch {
    return undefined
  }
}
